import styles from "./Switch.module.css";
import InputHeader from "../input/InputHeader";
import InputCard from "../containers/InputCard";

const Switch = ({ isChecked, setIsChecked, identifier, label }) => {
  const switchInputClass = isChecked
    ? styles.switchInputOn
    : styles.switchInputOff;

  return (
    <InputCard>
      <InputHeader text={label} />
      <input
        type="checkbox"
        className={switchInputClass}
        name={identifier}
        id={identifier}
        onChange={setIsChecked}
        checked={isChecked}
      />
    </InputCard>
  );
};

export default Switch;
